import React from "react";
import Slider from "react-slick";

function AutoPlaySlider({children, slidesToShow = 5}) {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: false,
    pauseOnFocus: false,
    swipeToSlide: true,
    arrows: false,
    draggable: false,
    touchMove: false,
    // centerPadding: "30px",
    adaptiveHeight: false,
  };
  return (
    <div className="w-full my-10 max-w-[1440px] mx-auto">
      <Slider {...settings}>
       {children}
      </Slider>
    </div>
  );
}

export default AutoPlaySlider;